import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';

(function($) {
    $(function() {
        $('.billboard--slideshow-view').slick({
            slidesToShow: 1,
            slidesToScroll:  1,
            arrows: false,
            fade: true,
            asNavFor: '.billboard--slideshow-thumbs',
            autoplay: true,
            autoplaySpeed: 5000
        });
        $('.billboard--slideshow-thumbs').slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: '.billboard--slideshow-view',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false
        });
    });
})(jQuery);